import { css } from "styled-components";
import token from "styled-token";
import { disabledMixin } from "../disabledMixin";
import { iconOffsetMixin } from "../iconOffsetMixin";
import { typographyMixin } from "../typographyMixin";
import { radioStateMixin } from "../radioStateMixin";
import { checkboxStateMixin } from "../checkboxStateMixin";
import { StyledListboxOptionLabel } from "../../components/Listbox/ListboxOptionLabel";
import { StyledListboxOptionMedia } from "../../components/Listbox/ListboxOptionMedia";

var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance,
      icon = props.icon;

  if (!appearance && !icon) {
    return "";
  }

  return token({
    fontType: "ListboxOption.fontType",
    mediaSize: "ListboxOption.mediaSize",
    iconSize: "ListboxOption.iconSize",
    iconColor: "ListboxOption.iconColor",
    horizontalSpacing: "ListboxOption.horizontalSpacing",
    verticalSpacing: "ListboxOption.verticalSpacing"
  }, function (tokens) {
    var styles = [css(["position:relative;padding-left:", "px;", "{position:absolute;height:", "px;width:", "px;left:", "px;top:", "px;display:flex;justify-content:center;align-items:center;}"], tokens.mediaSize + tokens.horizontalSpacing * 1.5, StyledListboxOptionMedia, tokens.mediaSize, tokens.mediaSize, tokens.horizontalSpacing, tokens.verticalSpacing)];

    if (icon) {
      styles.push(css(["", "{", " color:", ";}"], StyledListboxOptionMedia, iconOffsetMixin(Object.assign({}, props, {
        fontType: tokens.fontType,
        iconSize: tokens.iconSize
      })), tokens.iconColor));
      return styles;
    }

    styles.push(css(["", ":before{content:\"\";", "}&:hover:not([aria-disabled=\"true\"]) ", ":before{", "}&[aria-selected=\"true\"] ", ":before{", "}&[aria-disabled=\"true\"] ", ":before{cursor:default;}"], StyledListboxOptionMedia, radioStateMixin()(props), StyledListboxOptionMedia, radioStateMixin("hover")(props), StyledListboxOptionMedia, radioStateMixin("checked")(props), StyledListboxOptionMedia));

    if (appearance === "checkbox") {
      styles.push(css(["", ":before{", "}&[aria-selected=\"true\"] ", ":before{", "}"], StyledListboxOptionMedia, checkboxStateMixin()(props), StyledListboxOptionMedia, checkboxStateMixin("checked")(props)));
    }

    return styles;
  })(props);
};

export var ListboxOptionMixin = function ListboxOptionMixin(props) {
  return token({
    backgroundColorActive: "ListboxOption.backgroundColorActive",
    fontType: "ListboxOption.fontType",
    horizontalSpacing: "ListboxOption.horizontalSpacing",
    verticalSpacing: "ListboxOption.verticalSpacing"
  }, function (tokens) {
    return css(["cursor:pointer;padding:", "px ", "px;&:not([aria-disabled=\"true\"])[data-active=\"true\"]{background-color:", ";}&[aria-selected=\"true\"] ", "{font-weight:bold;}&[aria-disabled=\"true\"]{", "}", " ", ""], tokens.verticalSpacing, tokens.horizontalSpacing, tokens.backgroundColorActive, StyledListboxOptionLabel, disabledMixin(Object.assign({}, props, {
      disabled: true
    })), typographyMixin(Object.assign({
      fontType: tokens.fontType
    }, props)), appearanceCSS(props));
  })(props);
};